<template>
  <div class="col-xs-12 col-md-3">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="options"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import CampoEnum from "../../../../domain/protocolo/CampoEnum";
import ProtocoloEnum from "../../../../domain/protocolo/ProtocoloEnum";

export default {
  name: "c-protocolo-tipo-pessoa",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    options() {
      return [
        {
          value: "fisica",
          text: "Física"
        },
        {
          value: "juridica",
          text: "Jurídica"
        }
      ];
    },
    ambienteAtual() {
      return this.$store.state.ambientes.atual;
    }
  },
  asyncComputed: {
    setValue() {
      if (this.value) {
        let protocolo = this.formValues.protocolo[
          ProtocoloEnum.TERMO_COMPROMISSO_ESTAGIO
        ];
        if (!protocolo) {
          protocolo = this.formValues.protocolo[
            ProtocoloEnum.TERMO_COMPROMISSO_ESTAGIO_EAD
          ];
        }
        if (!protocolo && this.ambienteAtual.idAmbiente == 8) {
          protocolo = this.formValues.protocolo[
            ProtocoloEnum.TERMO_COMPROMISSO_ESTAGIO_MEDICINA
          ];
        }
        const isJuridica = ['juridica', ''].includes(this.value);
        const isFisica = ['fisica', ''].includes(this.value);
        if (isJuridica) {
          protocolo.campos[CampoEnum.CPF] = null;
        }

        if (isFisica) {
          protocolo.campos[CampoEnum.CNPJ] = null;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/TipoPessoa.vue